import React from "react"

const JoinCard = ( { planName, price, description, features, isPopular, buttonText } ) => {

  
    return (
      <div className={`flex flex-col p-6 top-40 mx-auto max-w-sm text-gray-900 bg-white rounded-lg shadow-lg border border-gray-200 ${isPopular ? 'border-blue-600 ring-2 ring-blue-600' : ''}`}>
      {isPopular && (
        <div className="mb-4 text-center text-sm font-semibold uppercase tracking-wide text-blue-600">
          Most Popular
        </div>
      )}
      <h3 className="mb-4 text-2xl font-semibold">{planName}</h3>
      <p className="font-light text-gray-500 sm:text-lg">{description}</p>
      <div className="flex justify-center items-baseline my-8">
        <span className="mr-2 text-5xl font-extrabold">{price}</span>
        <span className="text-gray-500">/month</span>
      </div>
      {/* Feature List */}
      <ul role="list" className="mb-8 space-y-4 text-left">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center space-x-3">
            {/* Checkmark Icon */}
            <svg className="shrink-0 w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"></path>
            </svg>
            <span>{feature}</span>
          </li>
        ))}
      </ul>
      <button 
        className={`mt-auto text-white focus:ring-4 focus:ring-blue-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${isPopular ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-600 hover:bg-gray-700'}`}
      >
        {buttonText}
      </button>
            
        
        
        


     
           
    </div>
  );
};
 
export default JoinCard;